// Navbar do site
import React, { useState } from 'react';
import "./Rodape.css";

function Rodape() {
    const [showPrivacyModal, setShowPrivacyModal] = useState(false);

    return (
        <>
            <footer>
                <div className="wrapper">
                    <p>
                    Copyright ©{new Date().getFullYear()} CIM Mulher. Todos direitos reservados.
                    </p>
                    <div className='right'>
                        <a onClick={() => setShowPrivacyModal(true)}>Política de Privacidade</a>
                    </div>
                </div>
            </footer>

            {showPrivacyModal && (
                <div className="modal-overlay" onClick={() => setShowPrivacyModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Política de Privacidade</h2>
                            <button className="close-btn" onClick={() => setShowPrivacyModal(false)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <h3>1. Informações que Coletamos</h3>
                            <p>
                                Através do nosso formulário de contato, coletamos apenas as informações que você nos fornece voluntariamente, que podem incluir:
                            </p>
                            <ul>
                                <li>Nome</li>
                                <li>Endereço de e-mail</li>
                                <li>Mensagem ou informações adicionais fornecidas</li>
                            </ul>

                            <h3>2. Como Utilizamos suas Informações</h3>
                            <p>
                                As informações coletadas são utilizadas exclusivamente para:
                            </p>
                            <ul>
                                <li>Responder às suas solicitações e dúvidas</li>
                                <li>Fornecer informações sobre nossos serviços</li>
                                <li>Manter contato relacionado às atividades do CIM Mulher</li>
                            </ul>

                            <h3>3. Proteção dos Dados</h3>
                            <p>
                                Adotamos medidas de segurança apropriadas para proteger suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição.
                            </p>

                            <h3>4. Compartilhamento de Informações</h3>
                            <p>
                                Não vendemos, trocamos ou transferimos suas informações pessoais para terceiros. Suas informações são tratadas com total confidencialidade.
                            </p>

                            <h3>5. Seus Direitos</h3>
                            <p>
                                Você tem o direito de:
                            </p>
                            <ul>
                                <li>Solicitar acesso aos seus dados pessoais</li>
                                <li>Solicitar correção de dados incorretos</li>
                                <li>Solicitar exclusão dos seus dados</li>
                            </ul>

                            <h3>6. Contato</h3>
                            <p>
                                Para questões sobre esta Política de Privacidade, entre em contato conosco através do e-mail: contato@cimmulher.org.br
                            </p>

                            <p className="last-updated">
                                <em>Última atualização: Outubro de 2025</em>
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Rodape;